import styled from 'styled-components';

export const PreferencesListV2Styles = styled.div`
  margin: 0 16px;
`;

export const PreferencesListV2ItemStyles = styled.div<{
  imageSrc: string;
  selected: boolean;
}>`
  position: relative;
  overflow: hidden;
  padding: 20px;
  border-radius: 16px;
  background: ${(props) => {
    if (props.selected) {
      return `#2D1A55`;
    }
    return `#30283E`;
  }};

  &:after {
    content: '';
    position: absolute;
    pointer-events: none;
    z-index: 1;
    display: block;
    width: 212px;
    height: 324px;
    top: 65px;
    right: 35px;
    transform: rotate(15deg) translateY(-50%);
    background: url(${(props) => props.imageSrc});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  &:before {
    content: '';
    visibility: ${(props) => (props.selected ? 'visible' : 'hidden')};
    position: absolute;
    border-radius: 16px;
    border: 2px solid #803eff;
    box-sizing: border-box;
    pointer-events: none;
    z-index: 2;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  &:not(:last-child) {
    margin-bottom: 12px;
  }

  .item-title {
    margin-top: 48px;
  }
`;
